export default __webpack_public_path__ + "static/productHeader-61675c2e0c9477192232ca9169d85c77.jpeg";